import FloatLabel from './FloatLabel';
export default FloatLabel;
